import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { doneAssetRentRequest } from '@api/assetsRent';

import { TDoneRequestParams } from '@interfaces/rent/dto/assetRentDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDoneAssetRentRequest = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const {
		mutate: doneAssetRentRequestCard,
	} = useMutation<TDoneRequestParams>({
		mutationKey: [ASSET_RENT_REQUEST_CARD, id],
		mutationFn: ({ id, comment }: TDoneRequestParams) => doneAssetRentRequest(id, comment),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentProposedDatesForItemSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
	});

	return {
		doneAssetRentRequest: doneAssetRentRequestCard as UseMutateFunction<any, any, TDoneRequestParams, any>,
	};
};
